<label
  class="block text-xs font-semibold text-[#25282D] mb-1"
  [ngClass]="labelClass"
>
  {{ label }}
  @if (showAsterisk) {
    <span class="text-orange-500 ml-1 text-xs font-semibold">*</span>
  }
</label>

<div class="relative w-full">
  <textarea
    [placeholder]="placeholder"
    [disabled]="isDisabled"
    [(ngModel)]="value"
    [readonly]="isReadOnly"
    [rows]="rows"
    (input)="onChange(value)"
    [ngClass]="{
      'placeholder:text-[#25282D] bg-[#E7E7EF] select-text pointer-events-none': isReadOnly,
      'bg-[#F8F8FE]': !isReadOnly
    }"
    class="w-full text-[#25282D] text-[12px] px-2 py-[7px] border border-[#DBE0E6] focus:outline-none focus:!border-[#C7B1FF] focus:ring-[#C7B1FF] rounded-[5px] placeholder:text-[12px] placeholder-[#96A0B5] focus:shadow focus:shadow-[#F0F0F0] resize-none"
  ></textarea>
</div>

